import { render, staticRenderFns } from "./SetReminderWindow.vue?vue&type=template&id=bf82f138&"
import script from "./SetReminderWindow.vue?vue&type=script&lang=js&"
export * from "./SetReminderWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf82f138')) {
      api.createRecord('bf82f138', component.options)
    } else {
      api.reload('bf82f138', component.options)
    }
    module.hot.accept("./SetReminderWindow.vue?vue&type=template&id=bf82f138&", function () {
      api.rerender('bf82f138', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/MblManagement/components/SetReminderWindow.vue"
export default component.exports